/* eslint-disable no-console -- simple logger */
import { APPLICATION_NAME } from '../constants';
export var LogLevel;

(function (LogLevel) {
  LogLevel[LogLevel["None"] = 0] = "None";
  LogLevel[LogLevel["Error"] = 1] = "Error";
  LogLevel[LogLevel["Warning"] = 2] = "Warning";
  LogLevel[LogLevel["Info"] = 3] = "Info";
  LogLevel[LogLevel["Debug"] = 4] = "Debug";
})(LogLevel || (LogLevel = {}));

export var DEFAULT_LOG_LEVEL = LogLevel.Warning;
export var logMethodsMap = new Map([[LogLevel.None, function () {}], [LogLevel.Error, console.error], [LogLevel.Warning, console.warn], [LogLevel.Info, console.info], [LogLevel.Debug, console.log]]);

var getTime = function getTime() {
  var date = new Date();
  var minutes = "0".concat(date.getMinutes());
  var seconds = "0".concat(date.getSeconds());
  var milliseconds = "00".concat(date.getMilliseconds());
  var LAST_TWO_DIGITS = -2;
  var LAST_THREE_DIGITS = -3;
  return "".concat(date.getHours(), ":").concat(minutes.slice(LAST_TWO_DIGITS), ":").concat(seconds.slice(LAST_TWO_DIGITS), ".").concat(milliseconds.slice(LAST_THREE_DIGITS));
};

export var getLogLevel = function getLogLevel() {
  var _localStorage$getItem;

  var result = Boolean(window.localStorage) && Number(JSON.parse((_localStorage$getItem = localStorage.getItem("".concat(APPLICATION_NAME, " debug"))) !== null && _localStorage$getItem !== void 0 ? _localStorage$getItem : String(DEFAULT_LOG_LEVEL)));

  if (typeof result !== 'number' || result < LogLevel.None || result > LogLevel.Debug) {
    result = DEFAULT_LOG_LEVEL;
  }

  return result;
};
export var log = function log(level) {
  var currentLevel = getLogLevel();

  if (currentLevel < level) {
    return;
  }

  var time = getTime();
  var method = logMethodsMap.get(level);

  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  method === null || method === void 0 ? void 0 : method.apply(void 0, ["%c".concat(time, " %c").concat(APPLICATION_NAME, ":"), 'color: #09c', 'color: #c90;'].concat(args));
};
export var logError = function logError() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  return log.apply(void 0, [LogLevel.Error].concat(args));
};
export var logWarning = function logWarning() {
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }

  return log.apply(void 0, [LogLevel.Warning].concat(args));
};
export var logInfo = function logInfo() {
  for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    args[_key4] = arguments[_key4];
  }

  return log.apply(void 0, [LogLevel.Info].concat(args));
};
export var logDebug = function logDebug() {
  for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    args[_key5] = arguments[_key5];
  }

  return log.apply(void 0, [LogLevel.Debug].concat(args));
};